import { render, staticRenderFns } from "./ReplyTransfer.vue?vue&type=template&id=48744b78"
import script from "./ReplyTransfer.vue?vue&type=script&lang=js"
export * from "./ReplyTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports